 document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.alignment-system').forEach(function(section) {
    
    var overlay = section.querySelector('.alignment-overlay');
    var desktopTips = Array.from(section.querySelectorAll('.hotspot-tooltip-desktop'));
    var mobileTips = Array.from(section.querySelectorAll('.hotspot-tooltip-mobile'));
    var currentIdx = null;

    // Mobile helpers
    function showMobile(idx) {
      currentIdx = idx;
      overlay.hidden = false;

      document.body.style.overflow = 'hidden';

      mobileTips.forEach(function (tip, i) {
        var isActive = i === idx;
        tip.hidden = !isActive;

        tip.querySelector('.mobile-tooltip-close').hidden = false;

        var btnPrev = tip.querySelector('.mobile-tooltip-prev');
        var btnNext = tip.querySelector('.mobile-tooltip-next');
        btnPrev.hidden = false;
        btnNext.hidden = false;
        btnPrev.disabled = i === 0;
        btnNext.disabled = i === mobileTips.length - 1;
      });
    }

    function hideMobile() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      mobileTips.forEach(function (tip) {
        tip.hidden = true;
        tip.querySelector('.mobile-tooltip-close').hidden = true;
        tip.querySelector('.mobile-tooltip-prev').hidden = true;
        tip.querySelector('.mobile-tooltip-next').hidden = true;
      });
    }

    section.querySelectorAll('.hotspot-btn').forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isMobile = window.innerWidth <= 767;

        if (isMobile) {
          showMobile(i);
        } else {
          // desktop toggle only your desktop tooltips
          desktopTips.forEach(function (tip, j) {
            if (j !== i) tip.hidden = true;
          });
          var me = desktopTips[i];
          me.hidden = !me.hidden;
        }
      });
    });

    // mobile prev/next/close
    mobileTips.forEach(function (tip, i) {
      tip.querySelector('.mobile-tooltip-close').addEventListener('click', hideMobile);

      tip.querySelector('.mobile-tooltip-prev').addEventListener('click', function () {
        if (currentIdx > 0) showMobile(currentIdx - 1);
      });

      tip.querySelector('.mobile-tooltip-next').addEventListener('click', function () {
        if (currentIdx < mobileTips.length - 1) showMobile(currentIdx + 1);
      });
    });

    // click-outside
    document.addEventListener('click', function (e) {
      if (!section.contains(e.target)) {
        if (window.innerWidth <= 767) hideMobile();
        else desktopTips.forEach((t) => (t.hidden = true));
      }
    });

    // on resize back to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) hideMobile();
    });
      });
  });